export default __webpack_public_path__ + "static/media/wireframe.7cff41a4.svg";